import { render, staticRenderFns } from "./DateTimeConfig.vue?vue&type=template&id=696a24ee&scoped=true"
import script from "./DateTimeConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a24ee",
  null
  
)

export default component.exports